var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.375V15.5H3.625L12.8417 6.28333L9.71667 3.15833L0.5 12.375ZM15.2583 3.86666C15.5833 3.54166 15.5833 3.01666 15.2583 2.69166L13.3083 0.741663C13.2312 0.6644 13.1397 0.603101 13.0389 0.561277C12.938 0.519453 12.83 0.497925 12.7208 0.497925C12.6117 0.497925 12.5036 0.519453 12.4028 0.561277C12.302 0.603101 12.2104 0.6644 12.1333 0.741663L10.6083 2.26666L13.7333 5.39166L15.2583 3.86666Z",
    fill: "#797A8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.f35eec055a55645545972cec628dd1b6.svg";
export { ForwardRef as ReactComponent };